// extracted by mini-css-extract-plugin
module.exports = {"c1paep96":"c1paep96"};